import React from 'react';
import { getFlightStatus } from './getFlightStatus';

export const FlightTimeDisplay = (props) => {
  const type = props.type
  const row = props.row
  const isDelayed = getFlightStatus(row);
  const originalTime = type === 'dep' ? row.Departure : row.Arrival
  const delayedTime = isDelayed ? (type === 'dep' ? row.ETD : row.ETA) : ''

  if (isDelayed==='Delayed') {
    let timeLoc = delayedTime.indexOf(':')
    let delayDisplay = `(${delayedTime.slice(timeLoc - 2, timeLoc + 3)})`
    
    return (
      <div>
        <div>{originalTime}</div>
        <div style={{color: 'red'}}>{delayDisplay}</div>
      </div>
    )
  }
  else if (isDelayed==='Preponded') {
    let timeLoc = delayedTime.indexOf(':')
    let delayDisplay = `(${delayedTime.slice(timeLoc - 2, timeLoc + 3)})`
    
    return (
      <div>
      <div>{originalTime}</div>
      <div style={{color: '#0000FF'}}>{delayDisplay}</div>
    </div>
    )
  }
  let timeLoc = delayedTime.indexOf(':')
  let delayDisplay = `(${delayedTime.slice(timeLoc - 2, timeLoc + 3)})`
  return (
    <div>
    <div>{originalTime}</div>
  </div>
  )
}